export default class UpdateUserPhoto {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  async execute(uid, photoURL) {
    // Mettre à jour l'URL de la photo directement dans le profil utilisateur principal
    return this.userRepository.updateUser(uid, { 
      photoURL: photoURL,
      updatedAt: new Date().toISOString()
    });
  }
}
